<div class="container" *ngIf="finishedLoading">
    <div class="row">
        <div class="col-sm-12">
            <h4>Aktionen</h4>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-3">
            <form class="example-form">
                <mat-form-field class="full-width" appearance="fill">
                    <mat-label>Suche</mat-label>
                    <input matInput [formControl]="this.filterForm.controls.searchTerm" placeholder="suchen..">
                </mat-form-field>
            </form>
        </div>
        <div class="col-sm-3 desktopFilter">
            <div class="centerAndJustify">
                <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Status</mat-label>
                    <mat-select [formControl]="this.filterForm.controls.filterState" multiple>
                        <mat-select-trigger>
                            <span *ngIf="this.filterForm.controls.filterState.value != null ">
                                {{this.filterForm.controls.filterState.value | translateFilterEvent : 'filterState'}}
                            </span>
                            <span *ngIf="this.filterForm.controls.filterState.value?.length > 1"
                                >
                                (+{{this.filterForm.controls.filterState.value.length - 1 }}
                                {{this.filterForm.controls.filterState.value?.length === 2 ? 'anderer'
                                :'andere' }})
                            </span>
                        </mat-select-trigger>
                        <mat-option *ngFor="let sortOption of sortOptionsState" [value]="sortOption.value">
                            {{sortOption.viewValue}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="col-sm-3 desktopFilter">
            <div class="centerAndJustify">
                <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Vorteil</mat-label>

                    <mat-select [formControl]="this.filterForm.controls.filterDiscountType" multiple>
                        <mat-select-trigger>
                            <span *ngIf="this.filterForm.controls.filterDiscountType.value != null ">
                                {{this.filterForm.controls.filterDiscountType.value | translateFilterEvent :
                                'filterDiscountType'}}
                            </span>
                            <span *ngIf="this.filterForm.controls.filterDiscountType.value?.length > 1"
                                >
                                (+{{this.filterForm.controls.filterDiscountType.value.length - 1 }}
                                {{this.filterForm.controls.filterDiscountType.value?.length === 2 ? 'anderer'
                                :'andere' }})
                            </span>
                        </mat-select-trigger>
                        <mat-option *ngFor="let sortOption of sortOptionsDiscountType" [value]="sortOption.value">
                            {{sortOption.viewValue}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="col-sm-12 marginBottom2Rem">
            <button mat-button mat-raised-button color="accent" (click)="filterEvents()" >
                Anwenden
            </button>
            <button mat-button mat-raised-button color="primary" (click)="resetFitler()" style="margin-left:15px;"
                [disabled]="!this.filterForm.touched">
                Filter zurücksetzen
            </button>
        </div>
    </div>
    <div class="row">
        <div *ngIf="this.allEvents.length == 0 && loaded">
            <h4>Keine Aktion mit diesen Kriterien gefunden</h4>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-4 marginBottom2Rem" *ngFor="let event of allEvents">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <div mat-card-avatar *ngIf="event.eventPartner?.links[1] != undefined">
                        <img class="example-header-image" src='{{event.eventPartner?.links[1]?.href}}' alt="">
                    </div>
                    <div mat-card-avatar *ngIf="event.eventPartner?.links[1] == undefined">
                        <img class="example-header-image" src="../../../../../assets/placeholders/logo.svg" alt="">
                    </div>
                    <mat-card-title-group>
                        <mat-card-title>{{event.title | truncate: 18 : true}}</mat-card-title>
                        <mat-card-subtitle>{{event.eventPartner.name | truncate: 25 : true}}</mat-card-subtitle>
                    </mat-card-title-group>
                    <div fxFlex></div>
                    <button mat-icon-button class="margintopNegative16" [matMenuTriggerFor]="menu" color="accent"
                        >
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="moveToReservations(event)">
                            <span>Gutscheine</span>
                        </button>
                        <!-- <button mat-menu-item (click)="openQRDialog(event)">
                            <span>Aktions QR-Code</span>
                        </button> -->
                        <button mat-menu-item (click)="downloadReservationList(event)"
                            [disabled]="event.totalActiveReservationsCount == '0' ">
                            <span>Reservierungsliste (XLS)</span>
                        </button>
                    </mat-menu>
                </mat-card-header>
                <img class="cardImage" *ngIf="event.image != null" mat-card-image src="{{event.image.url}}"
                    alt="Aktion_bild">
                <img class="cardImage" *ngIf="event.image == null" mat-card-image
                    src="../../../../../assets/placeholders/eventImage.png" alt="Aktion_bild">
                <mat-card-content>
                    <p class="eventDescription">
                        {{event.escapedDescription | truncate: 150 : false }}
                    </p>
                    <mat-divider></mat-divider>
                    <div class="quickFactsContainer">
                        <div class="flexCenter">
                            <mat-icon aria-hidden="false">date_range</mat-icon>
                            <h5 *ngIf="event.startDate != null">{{event.startDate | date:'dd.MM.yyyy'}} -
                                {{event.endDate | date:'dd.MM.yyyy'}}</h5>
                            <h5 *ngIf="event.startDate == null">Unbegrenzt</h5>
                        </div>
                        <div class="flexCenter">
                            <mat-icon aria-hidden="false">chrome_reader_mode</mat-icon>
                            <h5>{{event.totalActiveReservationsCount}}
                                <span *ngIf="event.reservationQuota > 0 "> von {{event.reservationQuota}}</span>
                                Reservierungen
                            </h5>
                        </div>
                        <div class="flexCenter">
                            <mat-icon aria-hidden="false">card_giftcard</mat-icon>
                            <h5>{{event.availableVoucherKeyCount}}
                                <span *ngIf="event.availableVoucherKeyCount != 1 ">
                                    verfügbare Gutscheincodes
                                </span>
                                <span *ngIf="event.availableVoucherKeyCount == 1 ">
                                    verfügbarer Gutscheincode
                                </span>
                            </h5>
                        </div>
                        <div class="flexCenter">
                            <mat-icon aria-hidden="false">label_important</mat-icon>
                            <h5>{{event?.attendanceCount}} Teilnahmen</h5>
                        </div>
                    </div>
                    <mat-divider></mat-divider>
                    <h6 class="subHeading">Status/Kategorien</h6>
                    <div class="interestsContainer">
                        <mat-chip-set>
                            <mat-chip class="primaryChip" selected>{{event.state |
                                translateState}}</mat-chip>
                            <mat-chip *ngFor="let category of event.interests| slice:0:4">{{category.name}}</mat-chip>
                        </mat-chip-set>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 marginBottom2Rem">
            <span *ngIf="allEvents?.length === 0" class="emptyTableState">Keine passenden Einträge
                gefunden...</span>
            <mat-paginator [length]="page.totalElements" class="paginator-centered" [pageSize]="page.size"
                [pageIndex]="page.number" (page)="loadPage($event)" [pageSizeOptions]="[12, 24, 36, 48]" *ngIf="page">
            </mat-paginator>
            <button class="fabAddBtnBottomRight" mat-fab color="accent" [routerLink]="['overview']"
                [disabled]="partnerHasNotAtLeastOneEvent">
                <mat-icon>add</mat-icon>
            </button>
        </div>
    </div>
</div>

<div class="container" *ngIf="!finishedLoading">
    <div class="row">
        <div class="col-sm-12 padding">
            <div class="loadingOverlay">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>
</div>